import React, { useEffect } from 'react';
import { Route, Routes as RouterRoutes } from 'react-router-dom';
import { connect } from 'react-redux';
import DashboardContainer from './components/DashboardContainer';
import ReEditContainer from './components/ReEditContainer';
import OrderDetailsContainer from './components/OrderDetailsContainer';
import WfoeMigrationStatus from './components/WfoeMigrationStatus';
import { loadDashboard } from './actions';
import ReworkSuccess from './components/ReworkSuccess';
var Routes = function Routes(_ref) {
  var init = _ref.init;
  useEffect(function () {
    init();
  }, []);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(RouterRoutes, null, /*#__PURE__*/React.createElement(Route, {
    path: "details/:externalId/rework-success/:data?",
    element: /*#__PURE__*/React.createElement(ReworkSuccess, null)
  }), /*#__PURE__*/React.createElement(Route, {
    path: "details/:externalId/:status?/:chatbot?",
    element: /*#__PURE__*/React.createElement(OrderDetailsContainer, null)
  }), /*#__PURE__*/React.createElement(Route, {
    path: "orders/:xid/:orderTitle/:from/:to/:page",
    element: /*#__PURE__*/React.createElement(DashboardContainer, null)
  }), /*#__PURE__*/React.createElement(Route, {
    path: "wfoe-migration-status",
    element: /*#__PURE__*/React.createElement(WfoeMigrationStatus, null)
  }), /*#__PURE__*/React.createElement(Route, {
    path: "re-edit/:externalId",
    element: /*#__PURE__*/React.createElement(ReEditContainer, null)
  }), /*#__PURE__*/React.createElement(Route, {
    index: true,
    element: /*#__PURE__*/React.createElement(DashboardContainer, null)
  })));
};
export default connect(null, {
  init: loadDashboard
})(Routes);